// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const FavoriteIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="FavoriteIcon" ref={forwardedRef} {...props}>
      <path d="M7.533 7.486 1.5 8.116 6 12l-1.268 6L10 15.001 15.274 18 14 12l4.5-3.883-6.021-.63L10 2zm2.47-2.08 1.53 3.389 3.601.377-2.675 2.309.798 3.762L10 13.39l-3.255 1.853.796-3.763-2.675-2.307L8.48 8.795z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const FavoriteIcon = /* @__PURE__ */ Object.assign(
  FavoriteIconComponent,
  { displayName: 'FavoriteIcon' },
);
